import React from "react";
import { Dropdown } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import i18n from "i18next";
import styled from "styled-components";
import { IMG_MM_FLAG, IMG_EN_FLAG, IMG_ZH_FLAG } from "../../assets/images";


const LanguageButton = styled.div`
  height: 48px;
  padding: 0 12px;
  border-radius: 8px;
  
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: #3566e8;
  }
`;

const Flag = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
`;

const languages = [
  { key: "en", label: "English", flag: IMG_EN_FLAG },
  { key: "mm", label: "Myanmar", flag: IMG_MM_FLAG },
  { key: "zh", label: "中文", flag: IMG_ZH_FLAG },
];

const LanguageSwitcher = () => {
  const currentLang = i18n.language || "en";

  const items = languages.map((lang) => ({
    key: lang.key,
    label: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          minWidth: 160,
        }}
      >
        <img
          src={lang.flag}
          alt={lang.label}
          style={{ width: 24, height: 24, borderRadius: "50%" }}
        />
        <span style={{ flex: 1 }}>{lang.label}</span>
        {currentLang === lang.key && (
          <CheckOutlined style={{ color: "#1859ff" }} />
        )}
      </div>
    ),
    onClick: () => i18n.changeLanguage(lang.key),
  }));

  const activeFlag =
    languages.find((l) => l.key === currentLang)?.flag || IMG_EN_FLAG;

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomRight"
      trigger={["click"]}
    >
      <LanguageButton>
        <Flag src={activeFlag} />
      </LanguageButton>
    </Dropdown>
  );
};

export default LanguageSwitcher;
